import React, { useContext, useState } from 'react';
import { SecondaryButton } from '../../../../../Core/FormInput';
import { Grid } from '@material-ui/core';
import { postTCard_CheckInReset, postTCard_ResetVehicleCollected } from '../../../../../Core/Service/communicator-service';
import AppContext from '../../../../../App/AppContext';
import formatters from '../../../../../Core/Grid/inputFormatter';
import DialogComp from '../../../../../Core/Modal/dialogModal';
import ConfirmationModal from '../../../../../Core/Controls/Dialog/ConfirmationModal';

const ResetCheckInOut = (props) => {
    const [modal, setModal] = useState({
        show: false,
        message: '',
        mode: ''
    });

    const { showToast } = useContext(AppContext);

    const handleSubmit = async () => {
        let res;

        if (modal.mode === 'A') {
            res = await postTCard_CheckInReset(props.tCardsID);
        } else if (modal.mode === 'C') {
            res = await postTCard_ResetVehicleCollected(props.tCardsID);
        }

        if (res.success) {
            showToast(res.message);
            props.onClose(true);
        } else {
            props.onClose(false);
        }

        setModal({ show: false, message: '', mode: '' });
    };

    const hideConfirmationModal = () => {
        setModal({
            show: false,
            message: '',
            mode: ''
        });
    };

    const handleReset = (mode) => {
        if (mode === 'A') {
            setModal({
                show: true,
                message: 'Are you sure to reset checkin?',
                mode: 'A'
            });
        } else if (mode === 'C') {
            setModal({
                show: true,
                message: 'Are you sure to reset checkout?',
                mode: 'C'
            });
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                {!props.hideHeader && (
                    <>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Reg No</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.reg || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Customer</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.cust || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Booking Date</div>
                            <div style={{ fontWeight: 'bold' }}>
                                {props.selectedVehicle?.bd ? formatters.MonthShortFormatter(props.selectedVehicle.bd) : 'N/A'}
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Status</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.status || 'N/A'}</div>
                        </Grid>
                    </>
                )}

                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <div style={{ marginBottom: '5px' }}>Arrived Date</div>
                            <div style={{ fontWeight: 'bold' }}>{props.arrived ? formatters.DateTimeFormatter(props.arrived) : 'N/A'}</div>
                        </Grid>
                        {props.arrived && (
                            <Grid item xs={4}>
                                <SecondaryButton fullWidth onClick={() => handleReset('A')}>
                                    Reset
                                </SecondaryButton>
                            </Grid>
                        )}
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <div style={{ marginBottom: '5px' }}>Collected Date</div>
                            <div style={{ fontWeight: 'bold' }}>{props.collected ? formatters.DateTimeFormatter(props.collected) : 'N/A'}</div>
                        </Grid>
                        {props.collected && (
                            <Grid item xs={4}>
                                <SecondaryButton fullWidth onClick={() => handleReset('C')}>
                                    Reset
                                </SecondaryButton>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <SecondaryButton className="Submitbtn" fullWidth onClick={() => props.onClose(false)}>
                        Cancel
                    </SecondaryButton>
                </Grid>
            </Grid>

            {modal.show && (
                <DialogComp onClose={hideConfirmationModal} title="Warning" maxWidth="sm" fullWidth>
                    <ConfirmationModal message={modal.message} handleSubmit={handleSubmit} handleCancel={hideConfirmationModal} />
                </DialogComp>
            )}
        </div>
    );
};

export default ResetCheckInOut;
